module.exports = __webpack_public_path__ + "img/logo-white.da2ac0ac.png";